import { useRef, useState } from 'react';
// material
import { alpha } from '@material-ui/core/styles';
import { Avatar, Button, Box, Divider, Typography } from '@material-ui/core';
// hooks
import useAuth from '../../hooks/useAuth';
// components
import { MIconButton } from '../../components/@material-extend';
import MenuPopover from '../../components/MenuPopover';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { logout, user = {}, isAuthenticated, signin } = useAuth() || {};
  const { profile, profiles } = user || {};
  const { email, name } = profile || profiles || {};

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar alt="My Avatar" src="/static/mock-images/avatars/avatar_default.jpg" />
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 220 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {name || 'anonymous'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {email || 'anonymous'}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ p: 2, pt: 1.5 }}>
          {(isAuthenticated && (
            <Button fullWidth color="inherit" variant="outlined" onClick={logout}>
              Logout
            </Button>
          )) || (
            <Button fullWidth color="inherit" variant="outlined" onClick={signin}>
              Login
            </Button>
          )}
        </Box>
      </MenuPopover>
    </>
  );
}
